import { application } from "./application"

import FlashMessagesController from "./flash_messages_controller"
import BookingController from "./booking_controller"
import BookingWizardController from "./booking_wizard_controller"
import BookingLineItemsController from "./booking_line_items_controller"
import CollapseController from "./collapse_controller"
import MenuLoaderController from "./menu_loader_controller"
import StripePaymentController from "./stripe_payment_controller"

application.register("flash-messages", FlashMessagesController)
application.register("booking", BookingController)
application.register("booking-wizard", BookingWizardController)
application.register("booking-line-items", BookingLineItemsController)
application.register("collapse", CollapseController)
application.register("menu-loader", MenuLoaderController)
application.register("stripe-payment", StripePaymentController)
